<div class="matero-error-wrap">
  <div class="matero-error-code">{{ code }}</div>
  <div *ngIf="title" class="matero-error-title">{{ title }}</div>
  <div *ngIf="message" class="matero-error-message">{{ message }}</div>
  <div>
    <a color="primary" mat-raised-button routerLink="/">{{ 'error-page.btn.back' | translate }}</a>
  </div>
</div>
